const authorityCheck = {
  pageAuthority: {
    // 页面权限
    '/zzjg/index': { roleKey: 'n1101' },
    '/zzjg/BranchesRebates': { roleKey: 'c1201' },
    '/rptMana/rptModelMana': { roleKey: 'n1401' },
    '/InventoryManagement/BasicSettings': { roleKey: 'cc101' },
    '/InventoryManagement/ImportSettings': { roleKey: 'cc10201' },
    '/InventoryManagement/INStoreImportSettings': { roleKey: 'cc10202' },
    '/InventoryManagement/OUTStoreImportSettings': { roleKey: 'cc10203' },
    '/InventoryManagement/SupplierManagement': { roleKey: 'cc10301' },
    '/InventoryManagement/CustomerInformation': { roleKey: 'cc10302' },
    '/InventoryManagement/cjManagement': { roleKey: 'cc10303' },
    '/InventoryManagement/WarehouseManagement': { roleKey: 'cc106' },
    '/InventoryManagement/CommodityManagement': { roleKey: 'cc104' },
    '/InventoryManagement/PurchaseOrder': { roleKey: 'cc107' },
    '/InventoryManagement/InboundMgn': { roleKey: 'cc108' },
    '/InventoryManagement/OutboundMgn': { roleKey: 'cc1010' },
    '/InventoryManagement/PlanOutOfStock': { roleKey: 'cc101101' },
    '/InventoryManagement/PlannedStorage': { roleKey: 'cc107' },
    '/InventoryManagement/SalesReturns': { roleKey: 'cc101102' },
    '/InventoryManagement/PurchaseReturn': { roleKey: 'cc101101' },
    '/InventoryManagement/InventoryLoss': { roleKey: 'cc10904' },
    '/InventoryManagement/InventoryProfit': { roleKey: 'cc10903' },
    '/InventoryManagement/InventoryChecking': { roleKey: 'cc10902' },
    '/InventoryManagement/InternalBusiness': { roleKey: 'cc10901' },
    '/TruckPositioning/LocateTheQuery': { roleKey: 'l101' },
    '/TruckPositioning/ConsumptionRecords': { roleKey: 'l102' },
    '/TruckPositioning/TopUpRecords': { roleKey: 'l103' },
    '/TruckPositioning/QueryRecords': { roleKey: 'l104' },
    '/QualityManage/ProblemAddOrModify': { roleKey: 'a11001' },
    '/QualityManage/NoHeaderfileAddOrModify': { roleKey: 'a11002' },
    '/ClaimsSettlement/ClaimsSettlementAdd': { roleKey: 'i1202' },
    '/Billing/CancelBill': { roleKey: 'c1317' },
    '/Billing/ReturnBill': { roleKey: 'c1320' },
    '/WarehouseManagement/supplier': { roleKey: 'r10101' },
    '/WarehouseManagement/materialCode': { roleKey: 'r10102' },
    '/WarehouseManagement/warehousingData': { roleKey: 'r10103' },
    '/WarehouseManagement/intoWarehouseManagement': { roleKey: 'r10201' },
    '/WarehouseManagement/outofWarehouseManagement': { roleKey: 'r10202' },
    '/WarehouseManagement/outdetail': { roleKey: 'r10202' },
    '/WarehouseManagement/inAndOutLaundryList': { roleKey: 'r10203' },
    '/WarehouseManagement/intoWarehouseManagementorder': { roleKey: 'r10701' },
    '/WarehouseManagement/outofWarehouseManagementorder': { roleKey: 'r10702' },
    '/WarehouseManagement/stockTaking': { roleKey: 'r10301' },
    '/WarehouseManagement/modifyRecord': { roleKey: 'r10303' },
    '/WarehouseManagement/indetail': { roleKey: 'r10201' },
    '/PleaseInquire/PleaseReview': { roleKey: 'c1103' },
    '/PleaseInquire/PleaseInquire_Index': { roleKey: 'c1104' },
    '/PermissionGroup/OnlineData': { roleKey: 'n1102' },
    '/FinancialReconciliation/CustomerReconciliation_F9': { roleKey: 'c1201' },
    '/FinancialReconciliation/ReconciliationBill': { roleKey: 'c1202' },
    '/FinancialReconciliation/CustomerReconciliationYdz_F9': {
      roleKey: 'c1213'
    },
    '/FinancialReconciliation/ReconciliationBillYdz': { roleKey: 'c1214' },
    '/FinancialReconciliation/ResidentreconciliationBill': { roleKey: 'c1210' },
    '/FinancialReconciliation/AgentReconciliation': { roleKey: 'c1203' },
    '/FinancialReconciliation/AgentReconciliationBill': { roleKey: 'c1204' },
    '/FinancialReconciliation/AgentReconciliationBillYdz': { roleKey: 'c1216' },
    '/FinancialReconciliation/CoachReconciliation': { roleKey: 'c1205' },
    '/FinancialReconciliation/ShorthaulReconciliation': { roleKey: 'c1206' },
    '/FinancialReconciliation/Company_ReconciliationBill': { roleKey: 'c1208' },
    '/FinancialReconciliation/BranchReconciliation_F9': { roleKey: 'c1201' },
    '/FinancialReconciliation/BranchReconciliationBill': { roleKey: 'c1202' },
    '/FinancialReconciliation/AgentReconciliationBill_DetailedAdd': {
      roleKey: 'c1203'
    },
    '/FinancialInstruments/ChangeWaybill': { roleKey: 'c1304' },
    '/FinancialInstruments/ReverseWriteOff': { roleKey: 'c1308' },
    '/FinancialInstruments/CustomerMerger': { roleKey: 'c1309' },
    '/FinancialInstruments/ProxyMerger': { roleKey: 'c1310' },
    '/czy/index': { roleKey: 'n1103' },
    '/Cashier/CashierZZ': { roleKey: 'c1115' },
    '/CashClassReport/CashSZReport': { roleKey: 'c1702' },
    '/baseSetting/shippernoSetting': { roleKey: 'n1501' },
    '/baseSetting/index': { roleKey: 'dailibsiteSetting' },
    '/FinancialPreparation/AccountDefinition': { roleKey: 'c1501' },
    '/FinancialPreparation/WriteOffSubject': { roleKey: 'c1502' },
    '/FinancialPreparation/b_dj_content': { roleKey: 'c1503' },
    '/FinancialPreparation/B_ACCOUNT_CN_BILLTYPE': { roleKey: 'c1504' },
    '/FinancialPreparation/AccountingItems': { roleKey: 'c1506' },
    '/FinancialPreparation/Subordinateline': { roleKey: 'c1508' },
    '/bankPrepare/PaymentMethod': { roleKey: 'c1507' },
    '/bankPrepare/index': { roleKey: 'c1505' },
    '/bankPrepare/CustomAccount': { roleKey: 'c1506' },
    '/Settlement/BindingDriver': {
      roleKey: function () {
        // /settlement/homeindex首页打开的页面不用检验页面权限
        if(!(window as any).isCustomizedHomePage()) {
          return 'kp111'
        }
      } 
    },
    '/Settlement/AddVehicleAuth': {
      roleKey: function () {
        // /settlement/homeindex首页打开的页面不用检验页面权限
        if(!(window as any).isCustomizedHomePage()) {
          return 'kp121'
        }
      } 
    },
    '/TransportResources/VehicleArchives': { roleKey: 'e11' },
    '/TransportResources/OperationExamination': { roleKey: 'e12' },
    '/TransportResources/Maintenance': { roleKey: 'e13' },
    '/TransportResources/Carrier': { roleKey: 'e14' },
    '/TransportResources/DeliveryFeeStandard': { roleKey: 'e15' },
    '/TransportResources/VehicleML75313': { roleKey: 'e16' },
    '/dhqr/index': { roleKey: 'a111' },
    '/reportTpl/branchProfit': { roleKey: 'c1709' },
    '/newCW/Index': {
      roleKey: function (query: any) {
        const lrtype = query.lrtype || ''
        const addOrEdit = query.addOrEdit || ''
        const xmtype = query.xmtype || ''
        if (lrtype == '0' && addOrEdit == 'addhx' && xmtype == '') {
          return 'c110701'
        } else if (lrtype == '0' && addOrEdit == 'add') {
          return ['c1105', 'c110902']
        } else if (lrtype == '0' && xmtype == '到款确认') {
          return 'c1113'
        } else if (lrtype == '0' && addOrEdit == 'addzjdb') {
          return 'c1114'
        } else if (lrtype == '1' && addOrEdit == 'add') {
          return ['c1106', 'c111002']
        } else if (lrtype == '1' && addOrEdit == 'addhx') {
          return 'c110702'
        } else if (lrtype == '2' && addOrEdit == 'add') {
          return 'c1101'
        }
      }
    },
    '/QualityManage/AsterAddOrModify': {
      roleKey: function (query: any) {
        const wtj = query.wtj || 0
        if (wtj > 0) {
          return 'i110207'
        } else {
          return 'a11003'
        }
      }
    },
    '/QuickFindResult/Index': {
      roleKey: function () {
        const tmscode = window.getNewUserInfo().TMSCode
        if (tmscode == '70268') {
          return 'q1'
        }
      }
    },
    '/CashDayAccount/CashDayAccount_Index': {
      roleKey: function (query: any) {
        const billtype = query.billtype
        if (billtype == 0) {
          return 'c1109'
        } else if (billtype == 1) {
          return 'c1110'
        }
      }
    },
    '/reportTpl/index': {
      roleKey: function () {
        let data: any = {}
        try {
          data = JSON.parse(window.$(frameElement).attr('src').split('?')[1])
        } catch (error) {
          data = location.search ? (window as any).strUrlObj() : {}
        }
        switch (data['data-view-type']) {
          case '前台收银日报表':
            return 'c1701'
          case '出纳余额汇总表':
            return 'c1703'
          case '科目明细分类账':
            return 'c1704'
          case '客户账龄分析表':
            return 'c1705'
          case '应收应付汇总表':
            return 'c1706'
          case '日记账变动报表':
            return 'c1707'
          case '单车毛利表':
            return 'c1708'
          case '网点利润表':
            return 'c1709'
          case '线路利润表':
            return 'c1710'
          case '营业额汇总表':
            return 'c140102'
          case '客户流失分析表':
            return 'c140303'
          case '运单大全':
            return 'c140101'
          case '未签货物日报表':
            return 'c140103'
          case '未出库货物日报表':
            return 'c140104'
          case '货物中转日报表':
            return 'c140105'
          case '未签回单日报表':
          case '未寄回单日报表':
          case '未回回单日报表':
          case '回单签收日报表':
          case '回单返回日报表':
          case '回单返厂日报表':
          case '回单寄出日报表':
          case '未返回单日报表':
          case '回单总账报表':
            return data.roleid
          case '未收货款日报表':
            return 'c140502'
          case '已收货款日报表':
            return 'c140506'
          case '未付货款日报表':
            return 'c140503'
          case '已付货款日报表':
            return 'c140505'
          case '货款变更日报表':
            return 'c140504'
          case '货款挂失日报表':
            return 'c140507'
          case '运费异动日报表':
            return 'c140601'
          case '货款总账报表':
            return 'c140501'
          case '业务员对账报表':
            return 'c140106'
          case '发车明细报表':
            return 'c140107'
          // 注释：2023年5月份以来，这个权限检验一直未生效，直到8月份有用户反馈这个页面无法打开，
          // 为了解决用户的需求，直接注释掉这个权限的校验
          // case "扫码收款报表": return 'c140108';
          case '网上对账报表':
            return 'c140111'
          case '系统收支报表':
            return 'c140115'
          case '大车费核销日报表':
            return 'c140112'
          case '返款日报表':
            return 'c140116'
          case '批量修改运费':
            return 'c1320'
          case '实名验证记录':
            return 'c140118'
          case '客服评价':
          case '下单统计报表':
          case '集包明细报表':
          case '催款客户信息':
            return 'c140101'
        }
      }
    }
  },
  pageCharge: {
    // 收费页面
    '/AcceptanceOfBill/index': {
      moduleName: '三包管理',
      judgment (query: any) {
        return Boolean(query.isdlkd_SB)
      }
    },
    '/Billing/AccCheck': { moduleName: '费用审核' },
    '/BillManagement/AddBillWarehousing': { moduleName: '票据管理' },
    '/BillManagement/AddBillCollarUse': { moduleName: '票据管理' },
    '/BillManagement/AddBillDistribution': { moduleName: '票据管理' },
    '/BillManagement/AddBillType': { moduleName: '票据管理' },
    '/CheckSheet/Main': { moduleName: '配载报账单' },
    '/CheckSheet/DriverFees': { moduleName: '配载报账单' },
    '/CheckSheet/ExpensesAlongTheWay': { moduleName: '配载报账单' },
    '/CheckSheet/OilCardFees': { moduleName: '配载报账单' },
    '/CheckSheet/ReturnCargo': { moduleName: '配载报账单' },
    '/CheckSheet/DepartureList': { moduleName: '配载报账单' },
    '/CheckSheet/FleetHome': { moduleName: '配载报账单' },
    '/CheckSheet/FleetInfo': { moduleName: '配载报账单' },
    '/InventoryManagement/SupplierManagement': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditSupplier': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditCustomer': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditCommodity': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditWarehouse': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditInbound': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditPurchaseOrder': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditInternalBusiness': {
      moduleName: '仓储管理'
    },
    '/InventoryManagement/AddOrEditInventoryChecking': {
      moduleName: '仓储管理'
    },
    '/InventoryManagement/AddOrEditInventoryProfit': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditInventoryLoss': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditOutbound': { moduleName: '仓储管理' },
    '/InventoryManagement/BasicSettings': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditPurchaseReturn': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditSalesReturns': { moduleName: '仓储管理' },
    '/InventoryManagement/ImportTemplate': { moduleName: '仓储管理' },
    '/InventoryManagement/InStore_ImportTemplate': { moduleName: '仓储管理' },
    '/InventoryManagement/InStoreImportCommodity': { moduleName: '仓储管理' },
    '/InventoryManagement/ImportCommodity': { moduleName: '仓储管理' },
    '/InventoryManagement/OutStoreUPIndex': { moduleName: '仓储管理' },
    '/InventoryManagement/OutStore_ImportTemplate': { moduleName: '仓储管理' },
    '/InventoryManagement/OutStoreImportCommodity': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditPlannedStorage': { moduleName: '仓储管理' },
    '/InventoryManagement/AddOrEditPlanOutOfStock': { moduleName: '仓储管理' },
    '/SendPack_SB/catch_Edit': { moduleName: '三包管理' },
    '/SendPack_SB/ChauffeurInfoAddOrEdit_SB': { moduleName: '三包管理' }
  },
  isLowerCase: false,
  toLowerCase () {
    if (this.isLowerCase) return
    let pageTemp = {}
    for (let key of Object.keys(this.pageCharge)) {
      pageTemp[key.toLocaleLowerCase()] = this.pageCharge[key]
    }
    (this.pageCharge as any) = pageTemp

    pageTemp = {}
    for (let key of Object.keys(this.pageAuthority)) {
      pageTemp[key.toLocaleLowerCase()] = this.pageAuthority[key]
    }
    (this.pageAuthority as any) = pageTemp
    this.isLowerCase = true
  },
  getCheckResult (moduleName) {
    let result = 0
    window.$.javaAjax({
      url: '/common/authorityCheck',
      data: { moduleName: moduleName },
      async: false,
      useCustomError: true,
      timeout: 10000,
      success (res) {
        result = Number(res.success)
      },
      error () {
        result = -1 // 表示网路异常
      }
    })
    return result
  },
  start(path: string, query: object) {
    // -1:网络异常  0:验证不通过（没有收费权限）  1:验证通过（收费权限和页面权限）  2:没有页面权限
    this.toLowerCase()

    // 页面权限检验
    let page = this.pageAuthority[path.toLocaleLowerCase()]
    if (page) {
      const roles = (window as any).GetUserAllRoles('', '', 'isNoShowMessage', '', 'isNoAddPathStrrole') || {};
      let roleKey = page.roleKey;
      if (typeof roleKey == "function") {
        roleKey = page.roleKey(query);
      }
      if (roleKey) {
        if (
          Array.isArray(roleKey) &&
          roleKey.every((key: string) => !roles[key])
        ) {
          return 2
        }
        if (typeof roleKey === 'string' && !roles[roleKey]) {
          return 2
        }
      }
    }

    // 收费权限检验
    page = this.pageCharge[path.toLocaleLowerCase()]
    if (page) {
      if (typeof page.judgment === 'function') {
        if (page.judgment(query)) {
          return this.getCheckResult(page.moduleName)
        }
      } else {
        return this.getCheckResult(page.moduleName)
      }
    }

    return 1
  }
}
export default authorityCheck
